module.exports = __webpack_public_path__ + "zl12-6c7c21fd.png";